import {
  Globe,
  Youtube,
  Instagram,
  Facebook,
  Music2,
  Twitter,
  type LucideIcon,
} from 'lucide-react';

// ponytail: fixed, suggested-only set of profile links. Add a platform = one entry here.
export const SOCIAL_PLATFORMS = [
  {
    key: 'website',
    label: 'Website',
    placeholder: 'yourwebsite.com',
    icon: Globe,
  },
  {
    key: 'youtube',
    label: 'YouTube',
    placeholder: 'youtube.com/@you',
    icon: Youtube,
  },
  {
    key: 'instagram',
    label: 'Instagram',
    placeholder: 'instagram.com/you',
    icon: Instagram,
  },
  {
    key: 'facebook',
    label: 'Facebook',
    placeholder: 'facebook.com/you',
    icon: Facebook,
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    placeholder: 'tiktok.com/@you',
    icon: Music2,
  },
  { key: 'x', label: 'X', placeholder: 'x.com/you', icon: Twitter },
] as const satisfies ReadonlyArray<{
  key: string;
  label: string;
  placeholder: string;
  icon: LucideIcon;
}>;
